export default __webpack_public_path__ + "58cd4c4c9802dc2aba72f5366ab2da97.glb";